import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useInbox from '../hooks/useInbox';
import '../css/InboxComponent.css';
import { ReactComponent as TrashIcon } from '../assets/Trash.svg';

const InboxComponent = ({ userId }) => {
    const { notifications, removeNotification, removeAllNotifications, loading, error, addNotificationToState } = useInbox(userId);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    const handleNotificationClick = (notification) => {
        if (notification.link) {
            navigate(notification.link);
            setDropdownOpen(false);
        }
    };

    useEffect(() => {
        if (dropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpen]);

    // WebSocket connection for real-time notifications
    useEffect(() => {
        // Only create WebSocket connection if userId exists
        if (!userId) {
            return;
        }

        const ws = new WebSocket('wss://api.csultimatefantasy.com/ws');

        ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                
                if (data.type === 'NEW_NOTIFICATION' && data.userID === userId) {
                    // Add the new notification to the state
                    addNotificationToState(data.notification);
                }
            } catch (error) {
                console.error('Error parsing WebSocket message:', error);
            }
        };

        return () => {
            ws.close();
        };
    }, [userId, addNotificationToState]);

    return (
        <div className="inbox-container" ref={dropdownRef}>
            <svg onClick={toggleDropdown} className={notifications.length > 0 ? 'notification-icon active' : 'notification-icon'} fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 611.999 611.999" xmlSpace="preserve">
                <path d="M570.107,500.254c-65.037-29.371-67.511-155.441-67.559-158.622v-84.578c0-81.402-49.742-151.399-120.427-181.203 C381.969,34,347.883,0,306.001,0c-41.883,0-75.968,34.002-76.121,75.849c-70.682,29.804-120.425,99.801-120.425,181.203v84.578 c-0.046,3.181-2.522,129.251-67.561,158.622c-7.409,3.347-11.481,11.412-9.768,19.36c1.711,7.949,8.74,13.626,16.871,13.626 h164.88c3.38,18.594,12.172,35.892,25.619,49.903c17.86,18.608,41.479,28.856,66.502,28.856 c25.025,0,48.644-10.248,66.502-28.856c13.449-14.012,22.241-31.311,25.619-49.903h164.88c8.131,0,15.159-5.676,16.872-13.626 C581.586,511.664,577.516,503.6,570.107,500.254z M484.434,439.859c6.837,20.728,16.518,41.544,30.246,58.866H97.32 c13.726-17.32,23.407-38.135,30.244-58.866H484.434z M306.001,34.515c18.945,0,34.963,12.73,39.975,30.082 c-12.912-2.678-26.282-4.09-39.975-4.09s-27.063,1.411-39.975,4.09C271.039,47.246,287.057,34.515,306.001,34.515z M143.97,341.736v-84.685c0-89.343,72.686-162.029,162.031-162.029s162.031,72.686,162.031,162.029v84.826 c0.023,2.596,0.427,29.879,7.303,63.465H136.663C143.543,371.724,143.949,344.393,143.97,341.736z M306.001,577.485 c-26.341,0-49.33-18.992-56.709-44.246h113.416C355.329,558.493,332.344,577.485,306.001,577.485z"></path>
            </svg>
            {notifications.length > 0 && (
                <div className='notification-count'>
                    <p>{notifications.length}</p>
                </div>
            )}
            {dropdownOpen && (
                <div className="inbox-dropdown">
                    <div className='inbox-navbar'>
                        <h3>Notifications</h3>
                        <p className='inbox-clearall' onClick={() => { removeAllNotifications(); setDropdownOpen(false); }}>Clear inbox</p>
                    </div>
                    <div className='inbox-inner'>
                        {loading && <div className='loader' />}
                        {error && <p>Error: {error}</p>}
                        {notifications.length === 0 &&
                            <h4 className='inbox-no-notification'>No notifications</h4>}
                        {notifications.length > 0 && !loading && !error && (
                            <ul style={{ width: '100%' }}>
                                {notifications.map((notification, index) => (
                                    <li key={index} onClick={() => notification.link ? handleNotificationClick(notification) : null} className='inbox-notification'>
                                        {notification.title}
                                        <div className='inbox-notification-date'>
                                            <p>{new Date(notification.date).toLocaleString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })}</p>
                                            <TrashIcon
                                                className="trash-icon"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    removeNotification(notification._id);
                                                }}
                                            />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default InboxComponent;